<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('hospital_public_panel.donation') }}</h4>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col xl="12" lg="12" sm="12">
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset" enctype="multipart/form-data">
                    <b-row>

                      <!-- Area Type -->
                      <b-col xl="6" lg="6" sm="12">
                        <ValidationProvider name="Area Type" vid="area_type_id" rules="required|min_value:1">
                            <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="area_type_id"
                              slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{$t('hospital_public_panel.area_type')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="donation.area_type_id"
                              :options="getAreaTypeList"
                              id="area_type_id"
                              @change="getAreaTypeData(donation.area_type_id)"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <!-- Division -->
                      <b-col xl="6" lg="6" sm="12">
                        <ValidationProvider name="Division" vid="division_id" rules="required|min_value:1">
                            <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="division_id"
                              slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{$t('hospital_public_panel.division')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="donation.division_id"
                              :options="divisionList"
                              id="division_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <!-- District -->
                      <b-col xl="6" lg="6" sm="12">
                        <ValidationProvider name="District" vid="district_id" rules="required|min_value:1">
                            <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="district_id"
                              slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{$t('hospital_public_panel.district')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="donation.district_id"
                              :options="districtList"
                              id="district_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <!-- City Corporation -->
                      <b-col xl="6" lg="6" sm="12" v-show="cityCorporationShow">
                        <ValidationProvider name="City Corporation" vid="city_corporation_id" :rules="`${cityCorporationShow ? 'required|min_value:1' : ''}`">
                            <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="city_corporation_id"
                              slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{$t('hospital_public_panel.city_corporation')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="donation.city_corporation_id"
                              :options="cityCorporationList"
                              id="city_corporation_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <!-- Upazila -->
                      <b-col xl="6" lg="6" sm="12" v-show="upazilaShow">
                        <ValidationProvider name="Upazila" vid="upazila_id" :rules="`${upazilaShow ? 'required|min_value:1' : ''}`">
                            <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="upazila_id"
                              slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{$t('hospital_public_panel.upazila')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="donation.upazila_id"
                              :options="upazilaList"
                              id="upazila_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <!-- Pourashava -->
                      <b-col xl="6" lg="6" sm="12" v-show="pourashavaShow">
                        <ValidationProvider name="Pourashava" vid="pourashava_id" :rules="`${pourashavaShow ? 'required|min_value:1' : ''}`">
                            <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="pourashava_id"
                              slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{$t('hospital_public_panel.pourashava')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="donation.pourashava_id"
                              :options="pauroshobaList"
                              id="pourashava_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                       <!-- Union -->
                      <b-col xl="6" lg="6" sm="12" v-show="unionShow">
                        <ValidationProvider name="Union" vid="union_id" :rules="`${unionShow ? 'required|min_value:1' : ''}`">
                            <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="union_id"
                              slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{$t('hospital_public_panel.union')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="donation.union_id"
                              :options="unionList"
                              id="union_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <!-- Hospital -->
                      <b-col xl="6" lg="6" sm="12">
                        <ValidationProvider name="Hospital" vid="hospital_id" rules="required|min_value:1">
                            <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="hospital_id"
                              slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{$t('hospital_public_panel.hospital')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="donation.hospital_id"
                              :options="hospitalList"
                              id="hospital_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <!-- Service Type -->
                      <b-col xl="6" lg="6" sm="12">
                        <ValidationProvider name="Service Type" vid="service_type_id" rules="required|min_value:1">
                            <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="service_type_id"
                              slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{$t('hospital_public_panel.service_type')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="donation.service_type_id"
                              :options="serviceTypeList"
                              id="service_type_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col xl="6" lg="6" sm="12">
                      </b-col>
                    </b-row>

                    <!-- Save/Cancel -->
                    <div class="row">
                      <div class="col-sm-3"></div>
                      <div class="col text-right">
                        <b-button type="submit" variant="primary" class="mr-2">{{ $t('globalTrans.search') }}</b-button>
                      </div>
                    </div>
                  </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <!-- Extra Info to be commented out later -->
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:body>
            <p style="color: black">City Corporation - Dhaka North - Popular</p>
            <p style="color: black">Union - Dhaka - Dhaka - Savar - Savar - Labaid</p>
            <p style="color: black">Pauroshoba - Dhaka - Dhaka - Savar - Savar - Medinova</p>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-modal id="modal-4" size="lg" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <FinancialModal :hospitalId="donation.hospital_id"/>
    </b-modal>

    <b-modal id="modal-5" size="xl" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <KindsModal :hospitalId="donation.hospital_id"/>
      <!-- <KindsModal :hospitalId="tempHospitalId"/> -->
    </b-modal>
  </b-container>
</template>
<script>

// import RestApi, { childServiceBaseUrl } from '@/config/api_config'
// import { seizerList, seizerStatus } from '../../api/routes'
import KindsModal from './Kinds'
import FinancialModal from './Financial.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import Custom from '../../../../../store/custom'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    KindsModal,
    FinancialModal,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      tempHospitalId: 22,
      /** */
      cityCorporationShow: false,
      upazilaShow: false,
      pourashavaShow: false,
      unionShow: false,
      districtList: [],
      cityCorporationList: [],
      upazilaList: [],
      unionList: [],
      pauroshobaList: [],
      hospitalList: [],
      /** */
      donation: {
        division_id: 0,
        district_id: 0,
        area_type_id: 0,
        city_corporation_id: 0,
        upazila_id: 0,
        pourashava_id: 0,
        union_id: 0,
        hospital_id: 0,
        service_type_id: 0,
        service_id: 0
      }
    }
  },
  computed: {
    isServiceTypeFinancial () {
      /** serviceTypeList | 1 = Kinds | 2 = Financial */
      return this.donation.service_type_id === 2
    },
    getAreaTypeList: function () {
      const objectData = Custom.wardTypeList
      return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.id, text: obj.name_bn }
          } else {
              return { value: obj.id, text: obj.name }
          }
      })
    },
    divisionList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    serviceTypeList: function () {
        const objectData = this.$store.state.HospitalDisabilityService.commonObj.serviceTypeList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    formTitle () {
      const title = this.isServiceTypeFinancial ? this.$t(('hospital_public_panel.financial')) : this.$t(('hospital_public_panel.kinds'))
      return this.$t(('hospital_public_panel.service_type')) + ` "${title}"`
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    'donation.division_id': function (newVal, oldVal) {
      this.donation.district_id = 0
      this.districtList = this.getDistrictList(newVal)
    },
    'donation.district_id': function (newVal, oldVal) {
      this.donation.city_corporation_id = 0
      this.donation.upazila_id = 0
      this.cityCorporationList = this.getCityCorporationList(newVal)
      this.upazilaList = this.getUpazilaList(newVal)
    },
    'donation.upazila_id': function (newVal, oldVal) {
      this.donation.pourashava_id = 0
      this.donation.union_id = 0
      this.unionList = this.getUnionList(newVal)
      this.pauroshobaList = this.getPauroshobaList(newVal)
    },
    /** City Corporation */
    'donation.city_corporation_id': function (newVal, oldVal) {
      if (this.donation.area_type_id === 1) {
        this.donation.hospital_id = 0
        if (newVal !== 0) {
          this.hospitalList = this.getHospitalListByCityCorporationId(newVal)
        } else if (newVal === 0) {
          this.hospitalList = []
        }
      }
    },
    /** Union */
    'donation.union_id': function (newVal, oldVal) {
      if (this.donation.area_type_id === 3) {
        this.donation.hospital_id = 0
        if (newVal !== 0) {
          this.hospitalList = this.getHospitalListByUnionId(newVal)
        } else if (newVal === 0) {
          this.hospitalList = []
        }
      }
    },
    /** Pourashava */
    'donation.pourashava_id': function (newVal, oldVal) {
      if (this.donation.area_type_id === 2) {
        this.donation.hospital_id = 0
        if (newVal !== 0) {
          this.hospitalList = this.getHospitalListByPourashavaId(newVal)
        } else if (newVal === 0) {
          this.hospitalList = []
        }
      }
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
    // this.$bvModal.show('modal-5')
  },
  methods: {
    getAreaTypeData (typeId) {
      /** Reset both hospital_id & hospitalList */
      this.donation.hospital_id = 0
      this.hospitalList = []

      /**
       * 1 - City Corporation (City-Coporation, Ward)
       * 2 - Pauroshoba (Upazila, Pourosoba, Ward)
       * 3 - Union (Upazila, Union, Ward)
       */
      switch (typeId) {
          case 0:
            this.cityCorporationShow = false
            this.upazilaShow = false
            this.pourashavaShow = false
            this.unionShow = false
            this.donation.city_corporation_id = 0
            this.donation.upazila_id = 0
            this.donation.pourashava_id = 0
            this.donation.union_id = 0
            break
          case 1:
            // City Corporation
            this.cityCorporationShow = true
            this.upazilaShow = false
            this.pourashavaShow = false
            this.unionShow = false
            this.donation.city_corporation_id = 0
            this.donation.upazila_id = 0
            this.donation.pourashava_id = 0
            this.donation.union_id = 0
            break
          case 2:
            // Pauroshoba
            this.cityCorporationShow = false
            this.upazilaShow = true
            this.pourashavaShow = true
            this.unionShow = false
            this.donation.city_corporation_id = 0
            // this.donation.upazila_id = this.donation.upazila_id
            this.donation.pourashava_id = 0
            this.donation.union_id = 0
            break
          case 3:
            // Union
            this.cityCorporationShow = false
            this.upazilaShow = true
            this.pourashavaShow = false
            this.unionShow = true
            this.donation.city_corporation_id = 0
            // this.donation.upazila_id = this.donation.upazila_id
            this.donation.pourashava_id = 0
            this.donation.union_id = 0
            break
        }
    },
    getDistrictList (divisionId = null) {
      return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === divisionId)
    },
    getCityCorporationList (districtId = null) {
      return this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
    },
    getUpazilaList (districtId = null) {
      return this.$store.state.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === districtId)
    },
    getUnionList (upazillaId = null) {
      return this.$store.state.commonObj.unionList.filter(item => item.status === 0 && item.upazilla_id === upazillaId)
    },
    getPauroshobaList (upazillaId = null) {
      return this.$store.state.commonObj.pauroshobaList.filter(item => item.status === 0 && item.upazilla_id === upazillaId)
    },
    getHospitalListByCityCorporationId: function (cityCorporationId) {
      return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.city_corporation_id === cityCorporationId)
    },
    getHospitalListByUnionId: function (unionId) {
      return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.union_id === unionId)
    },
    getHospitalListByPourashavaId: function (pourashavaId) {
      return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.pauroshoba_id === pourashavaId)
    },
    searchData () {
      if (this.isServiceTypeFinancial) {
        this.$bvModal.show('modal-4')
      } else {
        // isKinds
        this.$bvModal.show('modal-5')
      }
    },
    view (item) {
      this.editItemId = item.id
    },
    remove (item) {
      // this.changeStatus(childServiceBaseUrl, seizerStatus, item)
    },
    loadData () {
      // const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      // this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      // RestApi.getData(childServiceBaseUrl, seizerList, params).then(response => {
      //     if (response.success) {
      //       this.$store.dispatch('setList', response.data.data)
      //       this.paginationData(response.data)
      //     }
      //     this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      // })
    }
  }
}
</script>
